export default {
  state: {
    defaultData: [],
    routeData: {},
    routeEditData: Boolean,
  },

  getters: {
    getRouteGridData(state) {
      return state.defaultData;
    },
    
    getRouteData(state) {
      return state.routeData
    },

    getRouteEditData(state){
      return state.routeEditData
    }
  },

  mutations: {

    setRouteData(state, data) {
      const isNull = data === null;

      state.routeData = {
        id: !isNull ? data.id : "",
        name: !isNull ? data.name : "",
        polyclinic_id: !isNull ? parseInt(data.polyclinic_id) : "",
        macro_region_id: !isNull ? parseInt(data.macro_region_id) : "",
        origin_county_id: !isNull ? parseInt(data.origin_county_id) : "",
        destiny_county_id: !isNull ? parseInt(data.destiny_county_id) : "",
        estimated_time: !isNull ? data.estimated_time : "",
        km_total: !isNull ? data.km_total : "",

      }
    },
    setRouteEditData(state, data) {
      state.routeEditData = data

    }
  },

  actions: {
    changeRouteGridData(context, infos) {
      context.commit("setRouteGridData", infos);
    },

    changeRouteData(context, infos) {
      context.commit("setRouteData", infos)
    },

    changeRouteEditData(context, infos) {
      context.commit("setRouteEditData", infos)
    },
  },
};
